import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AlloxApiResponse } from '../models';
import { EnvironmentService } from './environment.service';


@Injectable({ providedIn: 'root' })
export class AlloxApiService {

  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  private baseUrl: string;

  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    this.baseUrl = environmentService.API_DOMAIN;
  }

  public get<T>(path: string, params: HttpParams = new HttpParams()): Observable<T> {
    return this.httpClient.get<AlloxApiResponse<T>>(this.baseUrl + path, { params })
      .pipe(map(this.response.bind(this)));
  }

  public put<T>(path: string, body: Object = {}): Observable<T> {
    return this.httpClient
      .put(this.baseUrl + path, JSON.stringify(body), this.options)
      .pipe(map(this.response.bind(this)));
  }

  public post<T>(path: string, body: Object = {}): Observable<T> {
    return this.httpClient
      .post(this.baseUrl + path, JSON.stringify(body), this.options)
      .pipe(map(this.response.bind(this)));
  }

  public delete<T>(path: string): Observable<T> {
    return this.httpClient.delete(this.baseUrl + path)
      .pipe(map(this.response.bind(this)));
  }

  private response<T>(response: AlloxApiResponse<T>) {
    return response.response;
  }

  private requestParse(json) {

  }
}
